export const bannerContent = {
	heading: "Empower Your Mind, Body, and Soul",
	description:
		"Welcome to our health and wellness blog, where we provide articles on mental health, fitness, nutrition, and self-care. Join us on a journey towards a healthier and happier life.",
	buttons: [
		{ title: "Get Started", link: "/get-started" },
		{ title: "Learn More", link: "/learn-more" },
	],
	carousel: {
		slides: [
			{
				src: "/images/bannerImages/img(1).jpg",
				alt: "Mental Health",
				heading: "Mental Health",
				description: "Explore our articles on mental health to improve your well-being and find inner peace.",
			},
			{
				src: "/images/bannerImages/img(2).jpg",
				alt: "Fitness",
				heading: "Fitness",
				description: "Get tips and routines to stay fit and active, no matter your fitness level.",
			},
			{
				src: "/images/bannerImages/img(3).jpg",
				alt: "Self Care",
				heading: "Self Care",
				description: "Find self-care practices that nurture your mind, body, and soul.",
			},
		],
	},
};
